<template>
  <div class="glass-icon" :class="[sizeClass, variantClass, { 'animated': animated }]">
    <!-- Custom SVG Icons -->
    <svg v-if="name === 'horse'" viewBox="0 0 576 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M448 238.1l0-78.1 16 0 9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1L576 80c0-19.1-8.4-36.3-21.7-48l5.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L480 0 448 0C377.3 0 320 57.3 320 128l-96 0-20.8 0-54.4 0c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256l0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9l33.7 0c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8L320 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-164.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"/>
    </svg>

    <svg v-else-if="name === 'user'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="1.5"/>
      <path d="M5 20C5 17.2386 8.13401 15 12 15C15.866 15 19 17.2386 19 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'veterinary'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="8" r="3" stroke="currentColor" stroke-width="1.5"/>
      <path d="M15 8C16.6569 8 18 6.65685 18 5V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M5 20C5 17.2386 8.13401 15 12 15C15.866 15 19 17.2386 19 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M8 21V19M16 21V19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'medical'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="7" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <path d="M12 11V17M9 14H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M7 7V5C7 3.89543 7.89543 3 9 3H15C16.1046 3 17 3.89543 17 5V7" stroke="currentColor" stroke-width="1.5"/>
    </svg>

    <svg v-else-if="name === 'orders'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.5 4.5H5.5L6.5 6.5M6.5 6.5L9 15.5H19L21 8.5H8M6.5 6.5L8 8.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="10" cy="19" r="1.5" stroke="currentColor" stroke-width="1.5"/>
      <circle cx="17" cy="19" r="1.5" stroke="currentColor" stroke-width="1.5"/>
    </svg>

    <svg v-else-if="name === 'profile'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="10" r="3" stroke="currentColor" stroke-width="1.5"/>
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
      <path d="M6 19.5C6.5 17 9 15 12 15C15 15 17.5 17 18 19.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'payment'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <path d="M2 9H22" stroke="currentColor" stroke-width="1.5"/>
      <path d="M6 14H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M14 14H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'address'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21C12 21 19 15.5 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10C5 15.5 12 21 12 21Z" stroke="currentColor" stroke-width="1.5"/>
      <circle cx="12" cy="10" r="2.5" stroke="currentColor" stroke-width="1.5"/>
    </svg>

    <svg v-else-if="name === 'cart'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4H6L7 8M7 8L9 16H19L21 8H7Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="10" cy="20" r="1" stroke="currentColor" stroke-width="1.5"/>
      <circle cx="18" cy="20" r="1" stroke="currentColor" stroke-width="1.5"/>
    </svg>

    <svg v-else-if="name === 'contact'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <path d="M3 7L12 13L21 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg v-else-if="name === 'dashboard'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="8" height="8" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <rect x="13" y="3" width="8" height="5" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <rect x="3" y="13" width="8" height="8" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <rect x="13" y="10" width="8" height="11" rx="2" stroke="currentColor" stroke-width="1.5"/>
    </svg>

    <svg v-else-if="name === 'users'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9" cy="8" r="3" stroke="currentColor" stroke-width="1.5"/>
      <path d="M2 20C2 17.2386 5.13401 15 9 15C12.866 15 16 17.2386 16 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <circle cx="17" cy="7" r="2.5" stroke="currentColor" stroke-width="1.5"/>
      <path d="M17 12C19.7614 12 22 13.7909 22 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'revenue'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
      <path d="M12 7V17M9 9.5C9 8.67157 10.3431 8 12 8C13.6569 8 15 8.67157 15 9.5C15 10.3284 13.6569 11 12 11C10.3431 11 9 11.6716 9 12.5C9 13.3284 10.3431 14 12 14C13.6569 14 15 14.6716 15 15.5C15 16.3284 13.6569 17 12 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'pending'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
      <path d="M12 7V12L15 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg v-else-if="name === 'transfer'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 10L3 14L7 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3 14H16C18.7614 14 21 11.7614 21 9V6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M17 6L21 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg v-else-if="name === 'search'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.5"/>
      <path d="M16 16L21 21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'add'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
      <path d="M12 8V16M8 12H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'settings'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
      <path d="M12 2V4M12 20V22M2 12H4M20 12H22M4.93 4.93L6.34 6.34M17.66 17.66L19.07 19.07M4.93 19.07L6.34 17.66M17.66 6.34L19.07 4.93" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'notification'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 3C8.68629 3 6 5.68629 6 9V13L4 16H20L18 13V9C18 5.68629 15.3137 3 12 3Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M10 20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20" stroke="currentColor" stroke-width="1.5"/>
    </svg>

    <svg v-else-if="name === 'logout'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 12H3M3 12L7 8M3 12L7 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M10 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'shield'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 3L4 7V12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12V7L12 3Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg v-else-if="name === 'qrcode'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
      <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
      <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
      <rect x="14" y="14" width="3" height="3" stroke="currentColor" stroke-width="1.5"/>
      <rect x="18" y="18" width="3" height="3" stroke="currentColor" stroke-width="1.5"/>
      <path d="M14 18H14.01M18 14H18.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'mobile'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="2" width="12" height="20" rx="3" stroke="currentColor" stroke-width="1.5"/>
      <path d="M10 18H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'stethoscope'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 4V11C6 13.7614 8.23858 16 11 16H13C15.7614 16 18 13.7614 18 11V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M4 4H8M16 4H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <circle cx="12" cy="20" r="2" stroke="currentColor" stroke-width="1.5"/>
      <path d="M12 16V18" stroke="currentColor" stroke-width="1.5"/>
    </svg>

    <svg v-else-if="name === 'heart'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 6C10-2 2 2 2 9C2 16 12 21 12 21C12 21 22 16 22 9C22 2 14-2 12 6Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg v-else-if="name === 'heartbeat'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 12H6L8 8L11 16L14 10L16 12H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg v-else-if="name === 'calendar'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <path d="M3 9H21" stroke="currentColor" stroke-width="1.5"/>
      <path d="M8 3V5M16 3V5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'document'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 3H6C4.89543 3 4 3.89543 4 5V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V9L14 3Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14 3V9H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8 13H16M8 17H12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'chart'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 3V21H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7 14V17M11 10V17M15 13V17M19 7V17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'star'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L14.9 8.6L22 9.3L17 14.1L18.2 21.2L12 17.8L5.8 21.2L7 14.1L2 9.3L9.1 8.6L12 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg v-else-if="name === 'check'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
      <path d="M8 12L11 15L16 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg v-else-if="name === 'arrow-right'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg v-else-if="name === 'location'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21C12 21 19 15.5 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10C5 15.5 12 21 12 21Z" stroke="currentColor" stroke-width="1.5"/>
      <circle cx="12" cy="10" r="2.5" stroke="currentColor" stroke-width="1.5"/>
    </svg>

    <svg v-else-if="name === 'paw'" viewBox="0 0 512 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5l0 1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3l0-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"/>
    </svg>

    <svg v-else-if="name === 'injection'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 2L22 6L20 8L16 4L18 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M16 4L6 14L4 20L10 18L20 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9 11L13 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'edit'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 3L21 8L8 21H3V16L16 3Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13 6L18 11" stroke="currentColor" stroke-width="1.5"/>
    </svg>

    <svg v-else-if="name === 'trash'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 7H20M10 11V17M14 11V17M5 7L6 19C6 20.1046 6.89543 21 8 21H16C17.1046 21 18 20.1046 18 19L19 7M9 7V4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg v-else-if="name === 'eye'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 12C2 12 5 5 12 5C19 5 22 12 22 12C22 12 19 19 12 19C5 19 2 12 2 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
    </svg>

    <svg v-else-if="name === 'download'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 3V15M12 15L8 11M12 15L16 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4 17V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'upload'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 15V3M12 3L8 7M12 3L16 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4 17V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'filter'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 6H21M7 12H17M10 18H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'sort'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 3V21M7 21L3 17M7 21L11 17M17 21V3M17 3L13 7M17 3L21 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg v-else-if="name === 'home'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 10L12 3L21 10V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V10Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9 21V12H15V21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg v-else-if="name === 'menu'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 6H20M4 12H20M4 18H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'close'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 6L18 18M6 18L18 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'plus'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'minus'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 12H19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'info'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
      <path d="M12 11V16M12 8V8.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'warning'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 3L22 20H2L12 3Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 10V14M12 17V17.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'error'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
      <path d="M15 9L9 15M9 9L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

    <svg v-else-if="name === 'success'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
      <path d="M8 12L11 15L16 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg v-else-if="name === 'refresh'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 12C3 7.02944 7.02944 3 12 3C15.3276 3 18.2354 4.80871 19.8039 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M21 12C21 16.9706 16.9706 21 12 21C8.67242 21 5.76457 19.1913 4.19609 16.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M21 3V8H16M3 21V16H8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg v-else-if="name === 'share'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
      <circle cx="18" cy="6" r="3" stroke="currentColor" stroke-width="1.5"/>
      <circle cx="18" cy="18" r="3" stroke="currentColor" stroke-width="1.5"/>
      <path d="M8.5 10.5L15.5 7.5M8.5 13.5L15.5 16.5" stroke="currentColor" stroke-width="1.5"/>
    </svg>

    <svg v-else-if="name === 'copy'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="8" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <path d="M16 8V6C16 4.89543 15.1046 4 14 4H6C4.89543 4 4 4.89543 4 6V14C4 15.1046 4.89543 16 6 16H8" stroke="currentColor" stroke-width="1.5"/>
    </svg>

    <svg v-else-if="name === 'lock'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="10" width="14" height="11" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <path d="M8 10V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7V10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <circle cx="12" cy="15" r="1" fill="currentColor"/>
    </svg>

    <svg v-else-if="name === 'unlock'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="10" width="14" height="11" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <path d="M8 10V7C8 4.79086 9.79086 3 12 3C13.8638 3 15.4299 4.27477 15.874 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <circle cx="12" cy="15" r="1" fill="currentColor"/>
    </svg>

    <!-- Fallback icon -->
    <svg v-else viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
      <path d="M12 8V12M12 16V16.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'GlassIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['xs', 'sm', 'md', 'lg', 'xl'].includes(value)
    },
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'primary', 'success', 'warning', 'danger', 'info', 'purple', 'pink', 'cyan', 'gradient-primary', 'gradient-success', 'gradient-purple', 'gradient-pink', 'gradient-cyan', 'gradient-orange', 'glass'].includes(value)
    },
    animated: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sizeClass() {
      return `size-${this.size}`;
    },
    variantClass() {
      return `variant-${this.variant}`;
    }
  }
};
</script>

<style scoped>
.glass-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.glass-icon svg {
  width: 50%;
  height: 50%;
}

/* Sizes */
.size-xs {
  width: 32px;
  height: 32px;
  border-radius: 10px;
}

.size-sm {
  width: 40px;
  height: 40px;
  border-radius: 12px;
}

.size-md {
  width: 56px;
  height: 56px;
  border-radius: 14px;
}

.size-lg {
  width: 70px;
  height: 70px;
  border-radius: 18px;
}

.size-xl {
  width: 100px;
  height: 100px;
  border-radius: 24px;
}

/* Variants - Solid Colors */
.variant-default {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  color: var(--color-text);
}

.variant-primary {
  background: rgba(59, 136, 165, 0.15);
  color: var(--theme-primary);
}

.variant-success {
  background: rgba(89, 169, 106, 0.15);
  color: var(--color-success);
}

.variant-warning {
  background: rgba(245, 158, 11, 0.15);
  color: var(--color-warning);
}

.variant-danger {
  background: rgba(239, 68, 68, 0.15);
  color: var(--color-danger);
}

.variant-info {
  background: rgba(var(--color-info-rgb), 0.15);
  color: var(--color-info);
}

.variant-purple {
  background: rgba(139, 92, 246, 0.15);
  color: #8b5cf6;
}

.variant-pink {
  background: rgba(236, 72, 153, 0.15);
  color: #ec4899;
}

.variant-cyan {
  background: rgba(6, 182, 212, 0.15);
  color: #06b6d4;
}

/* Variants - Gradients */
.variant-gradient-primary {
  background: linear-gradient(135deg, var(--theme-primary), var(--theme-primary-light));
  color: white;
  box-shadow: 0 8px 24px rgba(59, 136, 165, 0.3);
}

.variant-gradient-success {
  background: linear-gradient(135deg, var(--color-success), var(--color-success-light));
  color: white;
  box-shadow: 0 8px 24px rgba(89, 169, 106, 0.3);
}

.variant-gradient-purple {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
}

.variant-gradient-pink {
  background: linear-gradient(135deg, #f093fb, #f5576c);
  color: white;
  box-shadow: 0 8px 24px rgba(240, 147, 251, 0.3);
}

.variant-gradient-cyan {
  background: linear-gradient(135deg, #4facfe, #00f2fe);
  color: white;
  box-shadow: 0 8px 24px rgba(79, 172, 254, 0.3);
}

.variant-gradient-orange {
  background: linear-gradient(135deg, var(--color-warning), #f6d365);
  color: white;
  box-shadow: 0 8px 24px rgba(245, 158, 11, 0.3);
}

/* Glass variant */
.variant-glass {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: var(--color-text);
}

/* Animation */
.animated {
  animation: float 4s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

/* Hover effects for gradient variants */
.variant-gradient-primary:hover,
.variant-gradient-success:hover,
.variant-gradient-purple:hover,
.variant-gradient-pink:hover,
.variant-gradient-cyan:hover,
.variant-gradient-orange:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
}
</style>
